<template>
  <div class='sc-message--file'
      :class="{
        sent: message.author === 'me',
        received: message.author !== 'me'
      }">
     <!-- :style="messageColors" -->
    <div class='sc-message--file-icon'>
      <a :href="data.file.url || '#'" target='_blank'>
        <img src="./assets/file.svg" alt='generic file icon' height="60" />
      </a>
    </div>
    <div class='sc-message--file-name' >
      <!-- :style="messageColors" -->
      <a :href="data.file.url ? data.file.url : '#'" target='_blank'>{{data.file.name || ''}}</a>
    </div>
    <div class="sc-message--file-text" >
      <!-- :style="messageColors" -->
      {{data.text}}
      <p v-if="data.meta" class='sc-message--meta'>
         <!-- :style="messageColors" -->
         {{data.meta}}</p></div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
    // ,
    // messageColors: {
    //   type: Object,
    //   required: true
    // }
  }
}
</script>

<style scoped>

@import "./styles/fileMessage.css";

</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/FileMessage.vue